import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { useMediaQuery } from 'react-responsive';
import { getCurrentScope } from '@sentry/react';
import { initChatWidget, sendDataChatWidget, setYOffsetChatWidget } from 'utils/helpers';
import { identify } from '@commutifi-fe/logger';
import { CookieCategory, screenSizes } from 'constants/global';
import type { Account } from '@commutifi-fe/interfaces';
interface UseAccountAnalyticsProps {
  currentAccount: Account | undefined;
  email: string | undefined;
  name: string | undefined | null;
  cookieconsent: CookieConsent | null;
}

/**
 * Custom hook to handle third-party analytics and chat widget initialization
 * when the current account changes. This includes:
 * - Chat widget initialization and configuration
 * - LogRocket user identification
 * - Sentry user context setup
 * - Responsive adjustments for mobile devices
 */
export function useAccountAnalytics(t0) {
  const $ = _c(16);
  const {
    currentAccount,
    email,
    name,
    cookieconsent
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      maxWidth: screenSizes.xsMaxWidth
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const isXS = useMediaQuery(t1);
  let t2;
  if ($[1] !== cookieconsent || $[2] !== currentAccount || $[3] !== email || $[4] !== isXS || $[5] !== name) {
    t2 = () => {
      if (currentAccount?.id && email) {
        initChatWidget({
          id: currentAccount.id,
          enterpriseId: currentAccount.enterpriseId || "",
          organizationId: currentAccount.organizationId || "",
          segment: currentAccount.segment || "no-segment"
        });
        sendDataChatWidget(email);
        if (isXS) {
          setYOffsetChatWidget(60);
        }
        if (cookieconsent?.allowedCategory(CookieCategory.Analytics)) {
          identify({
            email: email || "",
            name: name || "Unknown",
            id: currentAccount.id
          });
          getCurrentScope().setUser({
            id: currentAccount.id,
            email
          });
        } else {
          getCurrentScope().setUser({
            id: currentAccount.id,
            ip_address: "not-your-business"
          });
          identify({
            id: currentAccount.id
          });
        }
      }
    };
    $[1] = cookieconsent;
    $[2] = currentAccount;
    $[3] = email;
    $[4] = isXS;
    $[5] = name;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const t3 = currentAccount?.id;
  const t4 = currentAccount?.enterpriseId;
  const t5 = currentAccount?.organizationId;
  const t6 = currentAccount?.segment;
  let t7;
  if ($[7] !== cookieconsent || $[8] !== email || $[9] !== isXS || $[10] !== name || $[11] !== t3 || $[12] !== t4 || $[13] !== t5 || $[14] !== t6) {
    t7 = [t3, t4, t5, t6, email, name, isXS, cookieconsent];
    $[7] = cookieconsent;
    $[8] = email;
    $[9] = isXS;
    $[10] = name;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  useEffect(t2, t7);
}